import react from "react";
import { createComponent } from "@lit/react";
import { MdIcon } from "@material/web/icon/icon";

export const LitIcon = createComponent({
  tagName: "md-icon",
  elementClass: MdIcon,
  react
});
